import axios from 'axios';
import apiConfig from '../api.config';

export default function copyFormConfig({ hotelId, data }) {
  const {
    host,
    URIs: { copyFormConfig },
  } = apiConfig;
  const uri = `${host}${copyFormConfig.replace(':hotelId', hotelId)}`;

  return axios
    .post(uri, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res;
    });
}
